// extracted by mini-css-extract-plugin
export default {"backdrop":"alertDismissible_backdrop__KzcjG","alert_main":"alertDismissible_alert_main__4chSO"};